export const stage: 'prd' | 'test' | 'dev' | 'ide' = import.meta.env.VITE_STAGE || 'production';

